/*
//-------------------------------------------------------
//   Copyright (c) 2021 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DayPartEnum
//   Details:    DayPartEnum constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 115164 12/10/21 JC       Added
//-------------------------------------------------------
*/

export const dayPartEnum = {
    full_day: 0,
    half_day: 1,
    morning: 2,
    afternoon: 3,
    hours: 4
};
